var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3171({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 34.2688V13.611L44.8841 0H0V78H58.5V77.8562C69.4663 76.6374 77.9951 67.353 78 56.0625C77.9951 44.7671 69.4663 35.4803 58.5 34.2688ZM43.8701 5.88169L52.6159 14.625H43.8701V5.88169ZM4.875 73.125V4.87013H39V19.4976H53.625V34.2688C49.3545 34.7417 45.4545 36.4382 42.2857 39H9.75V43.875H37.8227C36.8184 45.3765 36.0116 47.0169 35.3998 48.75H9.75V53.625H34.2688C34.1786 54.4269 34.125 55.2362 34.125 56.0625C34.125 62.9582 37.3133 69.1056 42.2882 73.125H4.875ZM56.0625 72.8398C46.7976 72.8179 39.3022 65.3226 39.2803 56.0625C39.3022 46.7976 46.7976 39.3022 56.0625 39.2803C65.3226 39.3022 72.8179 46.7976 72.8398 56.0625C72.8179 65.3226 65.3226 72.8179 56.0625 72.8398ZM48.75 29.25H9.75V34.125H48.75V29.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3125 60.9375L51.1875 65.8125L56.0625 60.9375L60.9375 65.8125L65.8125 60.9375L60.9375 56.0625L65.8125 51.1875L60.9375 46.3125L56.0625 51.1875L51.1875 46.3125L46.3125 51.1875L51.1875 56.0625L46.3125 60.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3171);
export default __webpack_public_path__ + "static/media/Group 3171.8cf0dd667112114930f020f5684f5402.svg";
export { ForwardRef as ReactComponent };